export default __webpack_public_path__ + "static/media/svg-4.bbfe55e7.svg";